<template>
  <div class="news">
    <Header active="job"></Header>
      <el-row class="banner" type="flex" align="middle">
          <el-col :span="2"></el-col>
          <el-col :span="4">
              <span class="business-title">人才招聘</span>
          </el-col>
      </el-row>

      <el-row class="team-container">
          <img class="team" src="../../assets/imgs/jobs/team.jpg" />
      </el-row>

      <el-row v-for="(item, index) in list" v-bind:key="item.id" class="news-item" v-bind:class="{'news-item-bg': (index + 1) % 2 !== 0}">

          <el-row>
              <el-col :span="16" @click.native="toInfo(item.id)">
                  <h2 class="job-title">{{item.title}}</h2>
              </el-col>
              <el-col :span="8" class="jobs-item">
                  <span class="right">
                      {{convertTime(item.createTime)}}
                  </span>
              </el-col>
          </el-row>
          <el-row>
              <p class="job-summary">
                  {{item.summary}}
              </p>
          </el-row>
          <el-row>
              <MainButton class="right" @click.native="toInfo(item.id)">详细信息</MainButton>
          </el-row>

      </el-row>

      <el-row class="page-container">
          <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page="page"
                  :page-count="totalPage"
                  @current-change="pageChange">
          </el-pagination>
      </el-row>

      <Footer></Footer>
  </div>
</template>
<script>
    import Header from '../../components/Header.vue'
    import Footer from '../../components/Footer.vue'
    import MainButton from "../../components/MainButton";
    import {jobApi} from "../../api/job-api";
    import {formatFromTimeString} from "../../utils/date";

    export default {
        name: 'Jobs',
        components: {MainButton, Header, Footer},
        data () {
            return {
                page: 1,
                limit: 5,
                totalPage: 1,
                list: []
            }
        },
        mounted () {
          this.listNews();
        },
        methods: {
            listNews () {
                jobApi.list({
                    status: 1,
                    page: this.page,
                    limit: this.limit
                }).then(res => {
                    if (res.code === 200) {
                        this.totalPage = res.page.totalPage;
                        this.list = res.page.list;
                    }
                })
            },
            pageChange (page) {
                this.page = page;
                this.listNews();
            },
            toInfo (id) {
                this.$router.push({
                    path: `/job/${id}`
                });
            }
        },
        computed: {
            convertTime () {
                return function (time) {
                    return formatFromTimeString(time);
                }
            }
        }
    }
</script>
<style scoped>
    .news {
        height: 100%;
        width: 100%;
    }
    .banner {
        height: 300px;
        width: 100%;
        background: url("../../assets/imgs/jobs/job_bg.jpg") no-repeat;
        background-size: 100% 100%;
    }
    .business-title {
        font-size: 36px;
        color: #ffffff;
        margin-top: 100px;
    }


    .news-item-bg {
        background: #f0f0f0;
    }

    .news-item {
        width: 100%;
        height: 250px;
        padding: 0 15%;
    }

    .jobs-item {
       line-height: 70px;
        font-size: 13px;
    }

    .job-title {
        text-align: left;
        cursor: pointer;
    }

    .job-summary {
        text-align: left;
    }

    .right {
        float: right;
    }

    .news-item:hover .job-title {
        color: #ff4e00;
    }

    .team {
        width: 100%;
        height: 200px;
    }

    .team-container {
        width: 70%;
        margin: 80px auto;
    }

    .page-container {
        margin: 80px 0;
    }


</style>
